/**
 * For documentation on masks, visit:
 *
 * https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#readme
 */

const nDigits = (n: number) => new Array(n).fill(/\d/);

export const loginPhoneNumberMask = [
  '(',
  ...nDigits(3),
  ')',
  ' ',
  ...nDigits(3),
  '-',
  ...nDigits(4),
];

export const giftCardNumberMask = [
  ...nDigits(4),
  ' ',
  ...nDigits(4),
  ' ',
  ...nDigits(4),
  ' ',
  ...nDigits(4),
];

export const giftCardPinMask = [...nDigits(4)];

const EMAIL_REGEX =
  /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/i;

// Keep in sync with workspaces/frontend/src/utils/form/index.ts (isNameInputValid)
const VALID_NAME_LETTERS =
  'a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõőøùúûüųūűÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕŐØÙÚÛÜŲŪŰŸÝŻŹÑßÇŒÆČŠŽ∂ð';

const INVALID_NAME_CHARACTER_REGEX = new RegExp(`[^${VALID_NAME_LETTERS} -]`);

export const hasInvalidNameCharacters = (name = ''): boolean =>
  INVALID_NAME_CHARACTER_REGEX.test(name);

/**
 * Validate that a string is an email address.
 *
 * The same function exists on the backend.
 * Changes here should be duplicated in common/src/utils/index.ts
 *
 * @param {string} email
 * The string to test.
 *
 * @returns {boolean}
 * True if the string provided is a valid email address.
 */
export const isEmailValid = (email = '') => {
  return EMAIL_REGEX.test(email) && email[0] !== '.' && !email.includes('..');
};

/**
 * Turns a 12-digit phone number into a well-formatted 10-digit phone number
 */
export function formatPhoneNumber(phoneNumber?: string) {
  if (phoneNumber && phoneNumber.length === 12) {
    const [a, b, c] = [
      phoneNumber.substring(2, 5),
      phoneNumber.substring(5, 8),
      phoneNumber.substring(8, 12),
    ];

    return `(${a}) ${b}-${c}`;
  }
  return phoneNumber ?? '';
}

/**
 * Remove all non-digits from a phone-number
 */
export function stripPhoneNumber(phoneNumberStr: string) {
  return phoneNumberStr.replaceAll(/\D/g, '');
}

export function isPhoneValid(phoneNumberStr) {
  return stripPhoneNumber(phoneNumberStr).length === 10;
}

export function isMonthValid(value: string) {
  return value.length === 2 && /^(0[1-9]|1[0-2])$/.test(value);
}

export function isDayValid(value: string) {
  return value.length === 2 && /^(0[1-9]|[12][0-9]|3[01])$/.test(value);
}

export function isYearValid(value: string) {
  return value.length === 4 && /^\d{4}$/.test(value);
}
